import { useEffect } from 'react';
import { useApiContext, useGetFreeSpins } from 'react-easyrocket';
import { useLocation } from 'react-router';
import { useFreeSpins } from 'src/hooks/useFreeSpins';
import { useModalContext } from 'src/hooks/useModalContext';

export function FreeSpinsHandler() {
  const { openModal } = useModalContext();
  const { saveFreeSpins, freeSpinsChanged } = useFreeSpins();
  const { isAuthenticated } = useApiContext();
  const location = useLocation();

  const { refetch } = useGetFreeSpins({
    onSuccess: (data) => {
      if (!location.pathname.includes('/game/') && isAuthenticated) {
        saveFreeSpins?.(data?.data?.freeSpins);
      }
      if (freeSpinsChanged) {
        openModal('FREESPINS');
      }
    }
  });

  useEffect(() => {
    if (!isAuthenticated) return;
    refetch();
  }, [isAuthenticated, freeSpinsChanged]);

  return null;
}
